import script from "./RemoveBG.vue?vue&type=script&setup=true&lang=js"
export * from "./RemoveBG.vue?vue&type=script&setup=true&lang=js"

import "./RemoveBG.vue?vue&type=style&index=0&id=5ccef640&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ccef640"]])

export default __exports__